import { Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import TwitterIcon from '@mui/icons-material/Twitter';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import HTML from '../../images/html.png'; 
import CSS from '../../images/css.png'
import JS from '../../images/js.png'
import Nodejs from '../../images/nodejs.png'
import Reactjs from '../../images/reactjs.png'
import Express from '../../images/express.png'
import Mongodb from '../../images/mongodb.png'
import './AllComponents.css'

export const SocialMedia = () => {
  return (
    <>
      <Typography
        variant='div'
        component={'div'}
        className='socialIcons'
      >
        <Typography
          className='iconP'
          variant='p'
          sx={{ mb: 3, border: '2px', fontSize: '1.2rem' }}
        >
          Follow me on
        </Typography>
        <Link to='https://www.linkedin.com/in/abhishekmaurya149/' target='_blank' className='socialIcon linkedin'><LinkedInIcon /></Link>
        <Link to='https://github.com/abhishekmaurya149' target='_blank' className='socialIcon github'><GitHubIcon /></Link>
        <Link to='https://twitter.com/mauryaj123123' target='_blank' className='socialIcon twitter'><TwitterIcon /></Link>
        {/* <Link to='' className='socialIcon'><InstagramIcon/></Link> */}

      </Typography>
    </>
  )
}



export const ContactHeading = () => {
  return (
    <>
      <Typography
        className='contactHeading education'
        variant='h3' sx={{
          textAlign: 'center',
          ml: 2,
          mr: 4
        }}>
        Contact Us
        <hr />
      </Typography>
    </>
  )
}


export const EducationHeading = () => {
  return (
    <>
      <Typography
        className='contactHeading education'
        variant='h3' sx={{
          textAlign: 'center',
          ml: 2,
          mr: 4
        }}>
        Education
        <hr />
      </Typography>
    </>
  )
}

export const SkillsHeading = () => {
  return (
    <>
      <Typography
        className='contactHeading education'
        variant='h3' sx={{
          textAlign: 'center',
          ml: 2,
          mr: 4
        }}>
        Skills
        <hr />
      </Typography>
    </>
  )
}

export const ProjectHeading = () => {
  return (
    <>
      <Typography
        className='contactHeading education'
        variant='h3' sx={{
          textAlign: 'center',
          ml: 2,
          mr: 4
        }}>
        Projects
        <hr />
      </Typography>
    </>
  )
}




export const Cube = () => {
  return (
    <>
      <div className="grid">
        <div className="cube_container">
          <div className="cube">
            <div style={{ '--x': -1, '--y': 0 }}>
              <span style={{ '--i': 3 }}></span>
              <span style={{ '--i': 2 }}></span>
              <span style={{ '--i': 1 }}></span>
            </div>
            <div style={{ '--x': 0, '--y': 0 }}>
              <span style={{ '--i': 3 }}></span>
              <span style={{ '--i': 2 }}></span>
              <span style={{ '--i': 1 }}></span>
            </div>
            <div style={{ '--x': 1, '--y': 0 }}>
              <span style={{ '--i': 3 }}></span>
              <span style={{ '--i': 2 }}></span>
              <span style={{ '--i': 1 }}></span>
            </div>
          </div>
          <div className="cube">
            <div style={{ '--x': -1, '--y': 0 }}>
              <span style={{ '--i': 3 }}></span>
              <span style={{ '--i': 2 }}></span>
              <span style={{ '--i': 1 }}></span>
            </div>
            <div style={{ '--x': 0, '--y': 0 }}>
              <span style={{ '--i': 3 }}></span>
              <span style={{ '--i': 2 }}></span>
              <span style={{ '--i': 1 }}></span>
            </div>
            <div style={{ '--x': 1, '--y': 0 }}>
              <span style={{ '--i': 3 }}></span>
              <span style={{ '--i': 2 }}></span>
              <span style={{ '--i': 1 }}></span>
            </div>
          </div>
          <div className="cube">
            <div style={{ '--x': -1, '--y': 0 }}>
              <span style={{ '--i': 3 }}></span>
              <span style={{ '--i': 2 }}></span>
              <span style={{ '--i': 1 }}></span>
            </div>
            <div style={{ '--x': 0, '--y': 0 }}>
              <span style={{ '--i': 3 }}></span>
              <span style={{ '--i': 2 }}></span>
              <span style={{ '--i': 1 }}></span>
            </div>
            <div style={{ '--x': 1, '--y': 0 }}>
              <span style={{ '--i': 3 }}></span>
              <span style={{ '--i': 2 }}></span>
              <span style={{ '--i': 1 }}></span>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}



export const HoverCard = () => {
  return (
    <>
      <div className="SkillsCard">
        <div className="align">
          <span className='red'></span>
          <span className='yellow'></span>
          <span className='green'></span>
        </div>
        <img src={HTML} alt="" />
        <p>HTML</p>
      </div>

    </>
  )
}



export const SkillsList = [
  {
    description: 'HTML',
    image:HTML
  },
  {
    description: 'CSS',
    image:CSS
  },{
    description: 'JS',
    image:JS
  },
  {
    description: 'Nodejs',
    image:Nodejs
  },
  {
    description: 'Reactjs',
    image:Reactjs
  },
  {
    description: 'Mongodb',
    image:Mongodb
  },
  {
    description: 'Express',
    image:Express
  }, 

];